import React, { Component } from "react";
import StepWizard from "react-step-wizard";
//// componentes reutilizables
import Titulo from "../../../generico/TituloPagina";
import Paso1 from "../transferenciaXpress/TransferenciaXpressPaso1";
import Paso2 from "../transferenciaXpress/TransferenciaXpressPaso2";
import Paso3 from "../transferenciaXpress/TransferenciaXpressPaso3";
import Paso4 from "../transferenciaXpress/TransferenciaXpressPaso4";

//TransferenciaXpress
export default class TransferenciaXpress extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
    this.paso4 = React.createRef();
  }
  resetState = () => {
    this.setState(this.getInitialState());
  };
  getInitialState = () => ({
    cuentaOrigen: {},
    cuentaDestino: {},
    importe: 0,
    nroOperacion: 0,
  });
  returnDataPaso1(_cuentaOrigen, _cuentaDestino) {
    this.setState({
      cuentaOrigen: _cuentaOrigen,
      cuentaDestino: _cuentaDestino,
    });
  }
  returnDataPaso2(_importe, _motivo, _celular) {
    this.setState({
      importe: _importe,
      motivo: _motivo,
      celular: _celular
    });
  }
  returnDataPaso3(_nroOperacion) {
    this.setState({
      nroOperacion: _nroOperacion,
    });
  }
  returnDataPaso4() {
    this.state = this.getInitialState();
    this.initDataChildren();
  }
  initDataChildren() {
    this.paso1.current.initData();
    this.paso2.current.resetState();
    this.paso3.current.resetState();
  }

  onStepChange = (stats) => {  
    if (stats.previousStep === 2) {      
      this.paso1.current.checkCuentaDestino();
    }
  };
  componentDidMount() {}

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Interbancarias 24 / 7" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card" >
                  <div className="card-body" style={{zIndex: 0}}>
                    <StepWizard
                      onStepChange={this.onStepChange}
                      transitions="none"
                    >
                      <Paso1
                        ref={this.paso1}
                        returnDataPaso1={this.returnDataPaso1.bind(this)}
                      />
                      <Paso2
                        ref={this.paso2}
                        cuentaOrigen={this.state.cuentaOrigen}
                        cuentaDestino={this.state.cuentaDestino}
                        returnDataPaso2={this.returnDataPaso2.bind(this)}
                      />
                      <Paso3
                        ref={this.paso3}
                        cuentaOrigen={this.state.cuentaOrigen}
                        cuentaDestino={this.state.cuentaDestino}
                        motivo={this.state.motivo}
                        importe={this.state.importe}
                        celular={this.state.celular}
                        returnDataPaso3={this.returnDataPaso3.bind(this)}
                      />
                      <Paso4
                        ref={this.paso4}
                        importe={this.state.importe}
                        nroOperacion={this.state.nroOperacion}
                        cuentaOrigen={this.state.cuentaOrigen}
                        cuentaDestino={this.state.cuentaDestino}
                        motivo={this.state.motivo}
                        celular={this.state.celular}
                        returnDataPaso4={this.returnDataPaso4.bind(this)}
                      />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
